export const mapTagToName: Dic<string> = {
  new: "New",
  soon: "Coming soon",
};

export const mapTagToVariant: Dic<string> = {
  new: "primary",
  soon: "disabled",
};
